<div class="card-component">
  <kendo-grid #grid [kendoGridBinding]="gridView">

    <kendo-grid-column field="data" [title]="customMsgService.translate('movDataHora')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.dataCriacao | date:"yyyy-MM-dd HH:mm:ss" }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="descricaoEstado" [title]="customMsgService.translate('estado')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
          <span kendoTooltip title="{{customMsgService.translate('datahoraAtualizacao')}}: {{dataItem.dataAtualizacao | date:'yyyy-MM-dd HH:mm:ss'}}">    
              <div class="customer-name"> {{ dataItem.descricaoEstado }} </div>
          </span>
      </ng-template>
  </kendo-grid-column>

    <kendo-grid-column field="identificacaodocumento" [title]="customMsgService.translate('identificacaodocumento')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.identificacaodocumento }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="iddoc" [title]="customMsgService.translate('iddoc')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.iddoc }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="idpagamento" [title]="customMsgService.translate('idpagamento')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.idpagamento }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="identidade" [title]="customMsgService.translate('identidade')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.identidade }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="faturaNumeroContribuinte" [title]="customMsgService.translate('faturaNumeroContribuinte')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.faturaNumeroContribuinte ? customMsgService.translate('yes') : customMsgService.translate('no') }} </div>
      </ng-template>
    </kendo-grid-column>
    
  </kendo-grid>
</div>

